export function useToken(token?: string) {
  return process.server && token
    ? useState<string>('token', () => token)
    : useState<string>('token');
}
